import _ from 'lodash';
import {
  getNbInCart,
  getProductId,
  removeUndefined,
  roundNumber,
} from '../../../../../../../../utils';
import {
  BNGM_SECTION_KEY,
  BNGM_SECTION_NAME,
  ITEM_KEY_COUNTER_SEPARATOR,
} from '../../../../../../../../constants';
import { showMessageModal } from '../../../../../../../../redux/actions';
import store from '../../../../../../../../redux/store';
import { getOptionsData } from '../../ProductModal.services';
import { sendGoogleAnalytics } from '../../../../../../../../api';
import { analyticsEvents } from '../../../../../../../../utils/firebaseAnalytics';
import { updatePendingOrderBasket } from '../../../../../../../../api/pendingOrder';
import { logHighError } from '../../../../../../../../utils/logger';
import {
  BuyNGetMMarketingCampaignConfig,
  MarketingCampaignType,
  Offer,
} from '../../../../../../../../1_types/genericTypes';

export const calculatePrice = (
  items: any,
  shopCategories: any,
  price: number | string,
  productOffer?: Offer,
): number => {
  let itemsPrice = 0;
  _.map(items, (item) => {
    const optionFree = shopCategories?.[item?.categoryKey]?.optionFree;
    if (item) {
      const itemOptions = _.values(item.options);
      if (
        item.categoryPosition === 0 &&
        productOffer &&
        item.categoryId.includes(productOffer.key) &&
        productOffer.type ===
          MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT
      ) {
        const config = productOffer.config as BuyNGetMMarketingCampaignConfig;
        const prices = itemOptions
          .map((option) => option.price)
          .sort((a, b) => b - a);

        const fullprices = _.sum(prices.slice(0, config.numProductsPaid));

        const discountedPrices =
          _.sum(prices.slice(config.numProductsPaid)) -
          (_.sum(prices.slice(config.numProductsPaid)) *
            config.discount.value) /
            100;

        itemsPrice += fullprices + discountedPrices;
      } else
        _.map(itemOptions, (option, index) => {
          if (!optionFree || index >= optionFree) {
            itemsPrice += parseFloat(option.price);
          }
        });
    }
  });
  const productPrice = parseFloat(price.toString());
  return roundNumber(productPrice + itemsPrice);
};

type AddToCartClickParams = {
  product: any;
  productOffer?: Offer;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  mandatoryCategories: any;
  items: any;
  productCategories: any;
  shopCategories: any;
  sectionName: string;
  nb: number;
  sectionKey: any;
  productKey: any;
  instruction: any;
  unit: any;
  shopId: string;
  resetComponent: (notHide: boolean) => void;
};

export const addToCartClick = async ({
  product,
  productOffer,
  setLoading,
  mandatoryCategories,
  items,
  productCategories,
  shopCategories,
  sectionName,
  nb,
  sectionKey,
  productKey,
  instruction,
  unit,
  shopId,
  resetComponent,
}: AddToCartClickParams): Promise<void> => {
  const selectedCampaignProductOption = _.chain(items)
    .values()
    .flatMap((item: any) => Object.values(item?.options || {}))
    .find((option: any) => option?.isMarketingCampaignMainProduct)
    .value() as any;

  if (
    productOffer?.type ===
    MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT
  ) {
    sectionKey = BNGM_SECTION_KEY;
    sectionName = BNGM_SECTION_NAME;
  }

  let resolvedProduct = product;
  let resolvedProductKey = productKey;
  let resolvedSectionKey = sectionKey;
  let resolvedSectionName = sectionName;

  if (
    selectedCampaignProductOption?.productKey &&
    selectedCampaignProductOption?.sectionKey
  ) {
    const { sections } = store.getState().shopReducer;
    const selectedSection = _.find(
      sections,
      (section) => section?.key === selectedCampaignProductOption.sectionKey,
    );
    const selectedProduct =
      selectedSection?.products?.[selectedCampaignProductOption.productKey];
    if (selectedProduct) {
      resolvedProduct = selectedProduct;
      resolvedProductKey = selectedCampaignProductOption.productKey;
      resolvedSectionKey = selectedCampaignProductOption.sectionKey;
      resolvedSectionName = selectedSection?.name || sectionName;
    }
  }

  const { name, price, key, position } = resolvedProduct;
  const {
    userConnected,
    user: { customerId },
    isUserAnonymous,
  } = store.getState().userReducer;
  try {
    setLoading(true);

    for (let i = 0; i < mandatoryCategories.length; i += 1) {
      const key = mandatoryCategories[i];
      if (!items[key]) {
        const categoryId = productCategories[key];
        const categoryKey = categoryId.split(ITEM_KEY_COUNTER_SEPARATOR)[0];
        const category = shopCategories?.[categoryKey];
        if (category) {
          const errorMessage = `Vous devez sélectionner l'option : ${category.name}`;
          store.dispatch(showMessageModal(errorMessage));
          setLoading(false);
        }
        return;
      }
    }
    const productId = getProductId(
      resolvedProductKey,
      items,
      instruction,
      productOffer?.key,
    );
    let cartNb = getNbInCart(productId) + Number(nb);
    let productPrice =
      calculatePrice(items, shopCategories, price, productOffer) * cartNb;
    if (unit) {
      cartNb = Number(nb);
      productPrice =
        (calculatePrice(items, shopCategories, price) * cartNb) /
        unit.conversion;
    }
    const newProduct = { ...resolvedProduct };
    newProduct.items = getOptionsData(items);
    newProduct.nb = cartNb;
    newProduct.unit = unit ? unit.name : null;
    newProduct.sectionName = resolvedSectionName;
    newProduct.sectionKey = resolvedSectionKey;
    newProduct.productKey = resolvedProductKey;
    newProduct.unitPrice = roundNumber(parseFloat(resolvedProduct.price));
    newProduct.price = roundNumber(productPrice);
    newProduct.shopId = shopId;
    newProduct.boughtPrice = !newProduct?.boughtPrice
      ? 0
      : roundNumber(newProduct.boughtPrice);
    if (instruction) {
      newProduct.instruction = instruction;
    }
    if (productOffer) {
      newProduct.productMarketingCampaignKey = productOffer.key;
      if (
        productOffer.type ===
        MarketingCampaignType.BUY_N_GET_M_CHEAPEST_AT_DISCOUNT
      ) {
        newProduct.isFakeProduct = true;
      }
    }
    if (userConnected || isUserAnonymous) {
      newProduct.items = removeUndefined(newProduct.items);
      const { message } =
        (await updatePendingOrderBasket(customerId, {
          [productId]: newProduct,
        })) || {};
      if (message) store.dispatch(showMessageModal(message));
    }
    setTimeout(() => {
      resetComponent(false);
    }, 1000);
    sendGoogleAnalytics('add_to_cart', {
      currency: 'EUR',
      items: [
        {
          id: key,
          name,
          price,
          position,
          category: resolvedSectionName,
          quantity: nb,
        },
      ],
      value: productPrice,
    });
    analyticsEvents.logAddToCart(
      key,
      name,
      price,
      resolvedSectionName,
      nb,
      position,
      'EUR',
    );
  } catch (error) {
    logHighError(
      `Error adding product ${key} with items ${JSON.stringify(
        items,
      )} to commande ${error}`,
    );
  }
  setLoading(false);
};
